class WordSearch {
  // 検索対象の文字列格納用
  wordlists = [];
  constructor() {
    const shop_box_element = document.querySelectorAll('.shop-list-box');
    // 初期化
    const search_word = document.getElementById('search_word');
    search_word.value = '';
    // 検索対象の文字列格納用
    shop_box_element.forEach((shop_element) => {
      const search_word =
        shop_element.querySelector('.shop-name').textContent +
        shop_element.querySelector('.shop-address').textContent;
      this.wordlists.push(search_word);
    });
    const show_box = (index) => {
      const shop_box_element = document.querySelectorAll('.shop-list-box');
      shop_box_element[index].style.display = 'block';
    };
    const hidden_box = (index) => {
      const shop_box_element = document.querySelectorAll('.shop-list-box');
      shop_box_element[index].style.display = 'none';
    };

    // 文字が含まれているかを検索する関数
    const showShopList = (word) => {
      // wordから全角スペースを除外する
      word = word.replace(/\s/g, '');
      console.log(word);
      // 入力値がからの場合はすべて表示
      if (word.trim() == '') {
        this.wordlists.forEach((wordlist, index) => {
          show_box(index);
        });
        return;
      }
      this.wordlists.forEach((wordlist, index) => {
        // 正規表現でwordlist内にwordの文字列が含まれているかを確認
        const regex = new RegExp(escapeRegExp(word), 'i');
        if (regex.test(wordlist)) {
          show_box(index);
        } else {
          hidden_box(index);
        }
      });
    };
    // 検索用
    const words = document.getElementById('search_word');
    // テキストボックス内でキーボードを押すと検索
    words.addEventListener('keyup', () => {
      showShopList(words.value);
    });
  }
}
// 正規表現で特殊文字をエスケープする関数
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
export { WordSearch };
